<div class="form-group">
  <label [class.pflichtfeld]="required" class="primaryFontColor">{{name}}</label>

  <div class="input-group">
    <input type="{{withTime ? 'datetime-local' : 'date'}}"
           class="form-control"
           [ngModel]="valAsStr()"
           (ngModelChange)="onInputChange($event)"
           [placeholder]="placeholder"
           [ngbTooltip]="tooltip">
    <div *ngIf="noData" class="input-group-append">
      <button type="button" class="btn btn-outline-secondary pcButton" (click)="applyNoData()">&Uuml;berspringen</button>
    </div>
  </div>
  <span *ngIf="!valid">Fehler bei der Eingabe.</span>
</div>
